import { withTheme } from "react-jsonschema-form";

import Theme from "../Theme";

const MuiForm = withTheme(Theme);

export default MuiForm;